/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ModerateNavigationContainer_story = {
    readonly id: string;
    readonly " $refType": "ModerateNavigationContainer_story";
};
export type ModerateNavigationContainer_story$data = ModerateNavigationContainer_story;
export type ModerateNavigationContainer_story$key = {
    readonly " $data"?: ModerateNavigationContainer_story$data;
    readonly " $fragmentRefs": FragmentRefs<"ModerateNavigationContainer_story">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ModerateNavigationContainer_story",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        }
    ],
    "type": "Story",
    "abstractKey": null
} as any);
(node as any).hash = 'f0a70c21a5f63d560f1603eb47cd916c';
export default node;
